import microModal from 'micromodal';
import { dateInTheFuture } from './date';

const COOKIE_NAME = 'acceptedCookiesAndAge';
const MODAL_ID = 'age-and-cookie-consent-modal';

const writeCookie = (cookieName, date) =>
  (document.cookie = `${cookieName}=true; path=/;expires=${date}`);

export function init() {
  microModal.init();

  if (document.cookie.indexOf(COOKIE_NAME) === -1) {
    microModal.show(MODAL_ID, {
      onClose: _ => writeCookie(COOKIE_NAME, dateInTheFuture()),
      disableScroll: true,
      debugMode: false,
    });
  }
}
